import { SearchMaskFeatureFlags } from '@webc/meeseeks-ui-sdk/build/types/definitions/components/SearchMaskFeatures';

export const FEATURE_DISTRIBUSION = 'feature.enable_distribusion';
export const FEATURE_ONLY_TRAIN_CITIES = 'feature.train_cities_only';
export const FEATURE_AUTO_UPDATE_DISABLED = 'feature.auto_update_disabled';
export const FEATURE_STATION_SUGGESTIONS_ENABLED =
  'feature.webc_search_station_suggestions_enabled';
export const FEATURE_LIMITED_PRODUCT_LIST = 'feature.webc_search_limited_product_list';

export const features: Partial<{ [key in SearchMaskFeatureFlags]: boolean }> = {
  [FEATURE_DISTRIBUSION]: true,
  [FEATURE_ONLY_TRAIN_CITIES]: false,
  [FEATURE_AUTO_UPDATE_DISABLED]: false,
  [FEATURE_STATION_SUGGESTIONS_ENABLED]: false,
  [FEATURE_LIMITED_PRODUCT_LIST]: false,
};

export const featuresToggledByCookies: {
  [flag in SearchMaskFeatureFlags]?: {
    cookieName: string;
    isEnabled: (cookieValue?: string) => boolean;
  };
} = {
  [FEATURE_DISTRIBUSION]: {
    cookieName: 'search_distribusion',
    isEnabled: (cookieValue?: string) => cookieValue === '1',
  },
  [FEATURE_AUTO_UPDATE_DISABLED]: {
    cookieName: 'search_auto_update_disabled',
    isEnabled: (cookieValue?: string) => cookieValue === '1',
  },
  [FEATURE_STATION_SUGGESTIONS_ENABLED]: {
    cookieName: 'webc_search_station_suggestions_enabled',
    isEnabled: (cookieValue?: string) => cookieValue === '1',
  },
  [FEATURE_LIMITED_PRODUCT_LIST]: {
    cookieName: 'webc_search_limited_product_list',
    isEnabled: (cookieValue?: string) => cookieValue === '1',
  },
};
